import { styled } from "@mui/material";

export const Type = styled("div")`
  margin: 0 5px;
  font-weight: 700;
`;
